module.exports = __webpack_public_path__ + "img/SMT_12_Mr_Wong_Loong_Mun.8d89f5bd.jpg";